module.exports = __webpack_public_path__ + "static/media/Fix_and_flip.0b077448.png";